import React from "react";
import {DescriptionPanel} from "../../../AppCore/Component/Panel";

export const CommitmentDescription = () => {
  return (
    <DescriptionPanel title={<span style={{color: '#878787'}}>PARTNER COMMITMENT</span>}>
        <p>
          The GreenLink Networks Partner Commitment outlines what we would like
          our relationship to be based on and how we feel you can get the most
          of our partnership. There are many commitments you can expect from our
          team and just a few things we expect from you.
        </p>
        <p>
          If you have any questions or concerns with the Partner Commitment, we
          would be happy to discuss it with you.
        </p>
      </DescriptionPanel>
  );
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/Commitment/CommitmentDescription.js